import { useEffect } from "react";

interface RedirectProps {
  to: string;
  replace?: boolean; // true = replace(), false = assign()
}

export function Redirect({ to, replace = false }: RedirectProps) {
  useEffect(() => {
    if (replace) {
      window.location.replace(to);
    } else {
      window.location.assign(to);
    }
  }, [to, replace]);

  return null;
}
